/* eslint-disable */ // v2
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import axios from 'axios'
import VueAxios from 'vue-axios'
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { Tabs, Tab } from 'vue3-tabs-component';
import "./assets/css/tabs-component.css";

const appInstance = createApp(App);
appInstance.use(VueAxios, axios);
appInstance.component('tabs', Tabs);
appInstance.component('tab', Tab);
appInstance.use(ToastPlugin);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");